/**
 * useCopyReturn
 *
 * Owns the copy-to-training / copy-to-live state that was previously class
 * state on FormViewer:
 *
 *   copyToTrainingDupeCheck()  — check for dupe SSN before copying to training
 *   copyToTraining()           — copy return to training database
 *   copyToLiveDupeCheck()      — check for dupe SSN before copying to live
 *   copyToLive()               — copy return to live database
 *
 * State returned for render:
 *   dupeSSNCopyRtnOpen      — boolean: dupe-SSN training confirm dialog open
 *   dupeSSNCopyLiveRtnOpen  — boolean: dupe-SSN live confirm dialog open
 *
 * Callers must supply:
 *   calcAPIRef            — ref to CalcAPI instance
 *   onShowPromptSnackbar  — callback (snackbars.showPromptSnackbar)
 */
import { useState, useCallback } from 'react';

const useCopyReturn = ({ calcAPIRef, onShowPromptSnackbar }) => {
  const [dupeSSNCopyRtnOpen, setDupeSSNCopyRtnOpen] = useState(false);
  const [dupeSSNCopyLiveRtnOpen, setDupeSSNCopyLiveRtnOpen] = useState(false);

  const copyToTrainingDupeCheck = useCallback(() => {
    calcAPIRef.current?.CopyToTrainingDupeCheck();
  }, [calcAPIRef]);

  const copyToTraining = useCallback(() => {
    calcAPIRef.current?.CopyToTraining();
    onShowPromptSnackbar('Tax return copied to training database');
  }, [calcAPIRef, onShowPromptSnackbar]);

  const copyToLiveDupeCheck = useCallback(() => {
    calcAPIRef.current?.CopyToLiveDupeCheck();
  }, [calcAPIRef]);

  const copyToLive = useCallback(() => {
    calcAPIRef.current?.CopyToLive();
    onShowPromptSnackbar('Tax return copied to live database');
  }, [calcAPIRef, onShowPromptSnackbar]);

  return {
    dupeSSNCopyRtnOpen,
    setDupeSSNCopyRtnOpen,
    dupeSSNCopyLiveRtnOpen,
    setDupeSSNCopyLiveRtnOpen,
    copyToTrainingDupeCheck,
    copyToTraining,
    copyToLiveDupeCheck,
    copyToLive,
  };
};

export default useCopyReturn;
